import { render } from "./CompanyFeedbackDialog.vue?vue&type=template&id=036da56f&scoped=true"
import script from "./CompanyFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./CompanyFeedbackDialog.vue?vue&type=script&lang=js"

import "./CompanyFeedbackDialog.vue?vue&type=style&index=0&id=036da56f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036da56f"]])

export default __exports__